/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import { AnyAction } from '@reduxjs/toolkit';
import * as actionTypes from '../constants/action-types';
import { ReduxStateLoadable } from './index';
import { BlueprintContributions } from '../types/survey';


export type BlueprintState = ReduxStateLoadable<BlueprintContributions> & { code?: string }

const defaultState: BlueprintState = {
  data: undefined,
  code: undefined,
  loaded: false,
  errored: false,
  errorMessage: ''
};

const blueprint = (state: BlueprintState = defaultState, action: AnyAction): BlueprintState => {
  switch (action.type) {
    case actionTypes.LOADING_BLUEPRINT:
      return {
        ...state,
        data: undefined,
        code: action.code,
        loaded: false,
        errored: false,
        lastUpdated: Date.now()
      }
    case actionTypes.ERROR_BLUEPRINT:
      return {
        ...state,
        data: undefined,
        code: undefined,
        loaded: false,
        errored: true,
        lastUpdated: Date.now(),
        errorMessage: action.errorMessage
      }
    case actionTypes.LOADED_BLUEPRINT:
      return {
        ...state,
        data: action.data,
        loaded: true,
        errored: false,
        lastUpdated: Date.now()
      }
    default:
      return state;
  }
}

export default blueprint;
